import * as React from "react";
import { cn } from "@/lib/utils";

/** 8-point star (two rotated hairline squares) framing a number. */
const Medallion: React.FC<React.PropsWithChildren<{ className?: string }>> = ({
	children,
	className,
}) => (
	<span
		aria-hidden
		className={cn(
			"relative grid size-11 shrink-0 place-items-center text-[13px] font-semibold tabular-nums text-emerald-900",
			className,
		)}
	>
		<span className="absolute inset-[18%] rounded-[3px] border border-gold-500/70" />
		<span className="absolute inset-[18%] rotate-45 rounded-[3px] border border-gold-500/70" />
		<span className="relative">{children}</span>
	</span>
);

export default Medallion;
